"use client";

import { useCallback, useRef, type ComponentType } from "react";

import { HomeGraphicShell } from "./home-graphic-shell";
import { preloadImages } from "./preload";

type SceneProps = { play: boolean };

export function CrunchGraphic() {
	const sceneRef = useRef<ComponentType<SceneProps> | null>(null);

	const onApproach = useCallback(async () => {
		const mod = await import("./crunch-scene");
		await preloadImages(mod.CRUNCH_COIN_PRELOAD);
		sceneRef.current = mod.CrunchScene;
	}, []);

	return (
		<HomeGraphicShell width={640} height={426} onApproach={onApproach}>
			{({ play, ready }) => {
				const Scene = sceneRef.current;
				return ready && Scene ? <Scene play={play} /> : null;
			}}
		</HomeGraphicShell>
	);
}
